/*  @ts-expect-error Jun-7-2024, 18:2UTC FixMe: Complete Migration to TypeScript  */

import get from 'transmute/get';
import getIn from 'transmute/getIn';
export const getLanguage = get('language');
export const getSearchableKnowledgeBaseIds = get('searchableKnowledgeBaseIds');
export const getGates = get('gates');
export const getEnableSdkCloseButton = get('enableSdkCloseButton');
export const getRecommendedQuestionsForAgent = get('recommendedQuestionsForAgent');
export const getChatflowName = widgetData => getIn(['message', 'name'], widgetData);